module.exports = __webpack_public_path__ + "img/undraw_group_chat_re_frmo 1.65bc6a87.svg";